import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { CredentialsService } from '@/features/auth/data-access/credentials.service';

function isLegacy(url: string): boolean {
    return url.includes('devapi.golfdigg.com') || url.includes('api.golfdigg.com') || url.includes(':8080/golfdigg');
}

export const jwtInterceptor: HttpInterceptorFn = (request, next) => {
    const token = inject(CredentialsService).token;
    if (!token) {
        return next(request);
    }

    let cloned = request;

    if (request.url.includes('ngrok')) {
        cloned = cloned.clone({
            setHeaders: {
                'ngrok-skip-browser-warning': 'true'
            }
        });
    }

    if (isLegacy(request.url)) {
        cloned = cloned.clone({
            setHeaders: {
                Authorization: `Bearer ${token}`
            }
        });
    } else {
        cloned = cloned.clone({
            setHeaders: {
                Authorization: `Bearer ${token}`
            }
        });
    }

    return next(cloned);
};
